<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox">
        <div class="ibox-title">
          <h5>Close Round</h5>
        </div>
        <div class="ibox-content">
          @if (selectedTournament() && selectedRound()) {
            <div class="round-close-container">
              <h3>{{ selectedTournament()!.name }}</h3>
              <h4>Round {{ selectedRound()!.number }}</h4>

              <div class="round-details">
                <div class="detail-row">
                  <span class="label-text">Status:</span>
                  <span [class]="selectedRound()!.official ? 'badge badge-primary' : 'badge badge-info'">
                    {{ selectedRound()!.official ? 'Official' : (selectedRound()!.active ? 'Active' : 'Not Started') }}
                  </span>
                </div>

                <div class="detail-row">
                  <span class="label-text">Start Date:</span>
                  <span>{{ selectedRound()!.startDate | date:'short' }}</span>
                </div>

                <div class="detail-row">
                  <span class="label-text">Unofficial Scorecards:</span>
                  <span [class]="unofficialCount() > 0 ? 'badge badge-warning' : 'badge badge-success'">
                    {{ unofficialCount() }}
                  </span>
                </div>
              </div>

              @if (hasUnofficialScorecards()) {
                <div class="alert alert-warning">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1 mr-4">
                      <i class="fa fa-warning"></i>
                      {{ unofficialCount() }} scorecards are still Unofficial. You must mark them Official before closing this round.
                      Admin-level permissions are required for this operation.
                    </div>
                    <div>
                      <button
                        type="button"
                        class="btn btn-warning btn-lg"
                        [disabled]="isMarkingOfficial()"
                        (click)="markAllUnofficialScorecardsOfficial()">
                        @if (isMarkingOfficial()) {
                          <i class="fa fa-spinner fa-spin"></i> Marking Official...
                        } @else {
                          <i class="fa fa-check-square-o"></i> Mark All Unofficial Official
                        }
                      </button>
                    </div>
                  </div>
                </div>
              }

              @if (closeResult()) {
                <div class="alert alert-info mt-3">
                  <h4>Close Round Summary</h4>
                  <ul class="list-unstyled">
                    @if (closeResult().isFinalRound) {
                      <li><i class="fa fa-flag"></i> This was the final round</li>
                    }
                    @if (closeResult().cutsApplied) {
                      <li><i class="fa fa-cut"></i> {{ closeResult().playersCutCount }} players were cut</li>
                    }
                    @if (closeResult().nextRoundPrepared) {
                      <li><i class="fa fa-check"></i> Next round prepared successfully</li>
                    }
                    @if (closeResult().purseAssigned) {
                      <li><i class="fa fa-money"></i> Purse assigned</li>
                    }
                    @if (closeResult().unofficialScorecardCount > 0) {
                      <li class="text-warning">
                        <i class="fa fa-warning"></i> {{ closeResult().unofficialScorecardCount }} unofficial scorecards
                      </li>
                    }
                  </ul>
                </div>
              }

              <div class="form-group">
                @if (showCloseButton()) {
                  <button 
                    type="button" 
                    class="btn btn-primary btn-lg"
                    [disabled]="isClosing()"
                    (click)="confirmCloseRound()">
                    @if (isClosing()) {
                      <i class="fa fa-spinner fa-spin mr-2"></i> Closing Round...
                    } @else {
                      <i class="fa fa-lock mr-2"></i> Close Round
                    }
                  </button>
                }
              </div>

              @if (!canClose()) {
                <div class="alert alert-warning mt-3">
                  <i class="fa fa-warning"></i>
                  @if (selectedRound()!.official) {
                    This round is already official and cannot be closed again.
                  } @else if (!selectedRound()!.active) {
                    This round must be active before it can be closed.
                  }
                </div>
              }
            </div>
          } @else {
            <div class="alert alert-warning">
              <i class="fa fa-warning"></i> No round selected. Please select a tournament and round from the main navigation.
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
